import React, { useState, useEffect } from 'react';
import { fetchWeather } from './api/fetchWeather';
import { fetchForecast } from './api/fetchForecast';
import './App.css';

const App = () => {
const [query, setQuery] = useState('');
const [weather, setWeather] = useState({});
const [forecast, setForecast] = useState([]);
const [error, setError] = useState('');

// Auto-ocultar error después de 5 segundos
useEffect(() => {
if (error) {
const timer = setTimeout(() => {
setError('');
            }, 5000);
            
return () => clearTimeout(timer);
        }
    }, [error]);

const search = async (e) => {
if (e.key === 'Enter' && query.trim() !== '') {
const { data, error: fetchError } = await fetchWeather(query);
if (fetchError) {
setError(fetchError);
setWeather({});
setForecast([]);
            } else {
setError('');
setWeather(data);
                
                // Obtener pronóstico de 5 días
const { data: forecastData } = await fetchForecast(query);
if (forecastData) {
setForecast(forecastData);
                }
            }
setQuery('');
        }
    };

const getDayName = (dateString) => {
const days = ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'];
const date = new Date(dateString);
return days[date.getDay()];
    };

return (
<div className="main-container">
<input
type="text"
className="search"
placeholder="Buscar..."
value={query}
onChange={(e) => setQuery(e.target.value)}
onKeyPress={search}
/>
{error && (
    <div className="error-message">
        <span role="img" aria-label="advertencia">⚠️</span> {error}
    </div>
)}
{weather.main && (
<div className="city">
<h2 className="city-name">
<span>{weather.name}</span>
<sup>{weather.sys.country}</sup>
</h2>
<div className="city-temp">
{Math.round(weather.main.temp)}
<sup>&deg;C</sup>
</div>
<div className="info">
<img
className="city-icon"
src={`https://openweathermap.org/img/wn/${weather.weather[0].icon}@2x.png`}
alt={weather.weather[0].description}
/>
<p>{weather.weather[0].description}</p>
</div>

                    {/* Pronóstico de 5 días */}
{forecast.length > 0 && (
<div className="forecast">
<h3 className="forecast-title">Próximos 5 días</h3>
<div className="forecast-container">
{forecast.map((day, index) => (
<div key={index} className="forecast-day">
<p className="forecast-day-name">
{getDayName(day.dt_txt)}
</p>
<img
className="forecast-icon"
src={`https://openweathermap.org/img/wn/${day.weather[0].icon}.png`}
alt={day.weather[0].description}
/>
<p className="forecast-temp">
{Math.round(day.main.temp)}°C
</p>
</div>
                                ))}
</div>
</div>
                    )}
</div>
            )}
</div>
    );
};

export default App;